/* eslint-disable no-unsafe-finally */

import { createPathComponent, createElementObject, extendContext } from "@react-leaflet/core";
import "leaflet.markercluster";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
Object.defineProperty(exports, "__esModule", { value: true });
var _MarkersGroup = void 0;
var _leaflet = _interopRequireDefault(require("leaflet"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : ("undefined" != typeof Symbol && arr[Symbol.iterator]) || arr["@@iterator"];
  if (null != _i) {
    var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
    try {
      if (((_x = (_i = _i.call(arr)).next), 0 === i)) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) {
        //
      }
    } catch (err) {
      _d = !0;
      _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && ((_r = _i["return"]()), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function getOptionsAndListeners(props) {
  var options = { removeOutsideVisibleBounds: true };
  var listeners = {};
  Object.entries(props).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      propName = _ref2[0],
      propValue = _ref2[1];
    !propName.startsWith("on") ? (options[propName] = propValue) : (listeners[propName] = propValue);
  });
  return { options: options, listeners: listeners };
}
function setListenerInMarkerClusterGroup(listeners, cluster) {
  Object.entries(listeners).forEach(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      eventAsProp = _ref4[0],
      callback = _ref4[1];
    var event = "cluster".concat(eventAsProp.substring(2).toLowerCase());
    cluster.on(event, callback);
  });
}
var MarkersGroup = (0, createPathComponent)(function (props, context) {
  var _getOptionsAndListene = getOptionsAndListeners(props),
    options = _getOptionsAndListene.options,
    listeners = _getOptionsAndListene.listeners;
  var cluster = new _leaflet["default"].markerClusterGroup(options);
  setListenerInMarkerClusterGroup(listeners, cluster);
  return (0, createElementObject)(cluster, (0, extendContext)(context, { layerContainer: cluster }));
});

_MarkersGroup = MarkersGroup;
export { _MarkersGroup as MarkersGroup };
